
import {Vue} from 'vue-class-component';

export default class SearchOutlineHeader extends Vue {
  dataSet = '2,114,526';
}
